import { lazy } from 'react';
import * as ROUTES from '../utils/urls';
import { validateEmpty, types, maxDays } from '../utils/helper';
import {
  selectContent,
  selectName,
  selectType,
  selectDaysRent,
  selectImage,
  selectBicycles,
  updateImage,
  updateValueInput,
  updateAmount,
  selectUrl
} from '../features/shopBicycleState/shopBicycleSlice';

const We = lazy(() => import('../pages/We'));
const Catalogue = lazy(() => import('../pages/Catalogue'));
const Input = lazy(() => import('./Input'));
const TextArea = lazy(() => import('./TextArea'));
const Select = lazy(() => import('./Select'));
const Image = lazy(() => import('./Image'));
const Invoice = lazy(() => import('../pages/Invoice'));
const History = lazy(() => import('../pages/History'));
const GroupCardByType = lazy(() => import('./GroupCardByType'));
const Detail = lazy(() => import('../pages/Detail'));
const Notification = lazy(() => import('../pages/Notification'));
const Users = lazy(() => import('../pages/Users'));
const Login = lazy(() => import('../pages/Login'));
const UsersList = lazy(() => import('../pages/UsersList'));
const WeList = lazy(() => import('../pages/WeList'));
const NewList = lazy(() => import('../pages/NewList'));
const WeAdmin = lazy(() => import('../pages/WeAdmin'));
const Company = lazy(() => import('../pages/Company'));
const CompanyList = lazy(() => import('../pages/CompanyList'));
const EditCompany = lazy(() => import('../pages/EditCompany'));
const EditNew = lazy(() => import('../pages/EditNew'));
const EditSection = lazy(() => import('../pages/EditSection'));
const EditUser = lazy(() => import('../pages/EditUser'));

export const components = {
  content: {
    body: [
      {
        _uid: '1',
        component: We,
        path: ROUTES.WE
      },
      {
        _uid: '2',
        component: Catalogue,
        path: ROUTES.CATALOGUE
      },
      {
        _uid: '3',
        component: Input,
        path: ROUTES.RENT_FORM,
        name: 'username',
        getData: selectName,
        saveData: updateValueInput,
        previous: ROUTES.CATALOGUE,
        next: ROUTES.PAYMENT_RENT,
        placeholder: 'Titulo',
        type: 'text',
        validate: validateEmpty
      },
      {
        _uid: '4',
        component: Select,
        path: ROUTES.TYPE_BICYCLE,
        name: 'type',
        getData: selectType,
        saveData: updateValueInput,
        previous: ROUTES.RENT_FORM,
        next: ROUTES.CONTENT_NEW,
        type: 'select',
        validate: validateEmpty,
        options: types,
        items: [{ id: 1, section: 'type', label: 'Type' }]
      },
      {
        _uid: '5',
        component: Select,
        path: ROUTES.DAYS_RENT,
        name: 'days',
        getData: selectDaysRent,
        saveData: updateValueInput,
        previous: ROUTES.TYPE_BICYCLE,
        next: ROUTES.BICYCLE_RENT,
        type: 'select',
        validate: validateEmpty,
        options: maxDays,
        items: [{ id: 1, section: 'days', label: 'Days' }]
      },
      {
        _uid: '6',
        component: GroupCardByType,
        path: ROUTES.BICYCLE_RENT,
        name: 'amountRent',
        getData: selectBicycles,
        saveData: updateAmount,
        previous: ROUTES.DAYS_RENT,
        next: ROUTES.PAYMENT_RENT,
        validate: validateEmpty
      },
      {
        _uid: '7',
        component: Image,
        path: ROUTES.PAYMENT_RENT,
        name: 'image',
        getData: selectImage,
        saveData: updateImage,
        previous: ROUTES.RENT_FORM,
        next: ROUTES.CONTENT_NEW,
        type: 'file'
      },
      {
        _uid: '8',
        component: Invoice,
        path: ROUTES.RESUME,
        previous: ROUTES.CONTENT_NEW,
        next: ROUTES.HISTORY_RENT
      },
      {
        _uid: '9',
        component: History,
        path: ROUTES.HISTORY_RENT
      },
      {
        _uid: '10',
        component: TextArea,
        path: ROUTES.CONTENT_NEW,
        name: 'content',
        getData: selectContent,
        saveData: updateValueInput,
        previous: ROUTES.PAYMENT_RENT,
        next: ROUTES.LINK,
        placeholder: 'Contenido',
        type: 'text',
        validate: validateEmpty
      },
      {
        _uid: '15',
        component: Input,
        path: ROUTES.LINK,
        name: 'url',
        getData: selectUrl,
        saveData: updateValueInput,
        previous: ROUTES.CONTENT_NEW,
        next: ROUTES.RESUME,
        placeholder: 'www.sifonecompany.com',
        type: 'text',
        validate: validateEmpty
      },
      {
        _uid: '11',
        component: Detail,
        path: ROUTES.NEW_DETAIL
      },
      {
        _uid: '12',
        component: Notification,
        path: ROUTES.NOTIFICATION
      },
      {
        _uid: '13',
        component: Login,
        path: ROUTES.LOGIN
      },
      {
        _uid: '16',
        component: Users,
        path: '/users'
      },
      {
        _uid: '17',
        component: UsersList,
        path: '/list'
      },
      {
        _uid: '17',
        component: WeAdmin,
        path: '/admin-quienes-somos'
      },
      {
        _uid: '18',
        component: Company,
        path: '/company'
      },
      {
        _uid: '19',
        component: CompanyList,
        path: '/list-companies'
      },
      {
        _uid: '20',
        component: EditCompany,
        path: '/edit-company'
      },
      {
        _uid: '21',
        component: EditUser,
        path: '/edit-user'
      },
      {
        _uid: '22',
        component: WeList,
        path: '/we-list'
      },
      {
        _uid: '23',
        component: EditSection,
        path: '/edit-section'
      },
      {
        _uid: '24',
        component: NewList,
        path: '/new-list'
      },
      {
        _uid: '25',
        component: EditNew,
        path: '/edit-new'
      }
    ]
  }
};
